/**
 * Browser-side Supabase auth options shared by dashboard-frontend and
 * analytics-frontend.
 *
 * Pinned as a shared constant (rather than a `createClient` factory in this
 * package) so the `@supabase/supabase-js` SDK doesn't have to be installed
 * inside `packages/web-shared/` for type resolution — each consumer brings
 * its own SDK and calls `createClient(url, key, { auth: BROWSER_SUPABASE_AUTH_OPTIONS })`.
 *
 * **detectSessionInUrl: false is non-negotiable.** Leaving it on lets Supabase
 * silently consume any URL fragment shaped like `#access_token=<jwt>`,
 * overwriting the live session in localStorage. Because dashboard-frontend
 * and analytics-frontend share the same origin (#617), that fragment is an
 * attack on both apps simultaneously. Neither SPA initiates OAuth or
 * magic-link flows that would legitimately land here.
 *
 * **persistSession + autoRefreshToken on** match the SDK defaults but are
 * pinned explicitly so future SDK default changes can't quietly turn either
 * off and log users out across reloads.
 *
 * **`storageKey` is deliberately absent** so both SPAs keep the SDK default
 * (`sb-<project-ref>-auth-token`). Same-origin (#617) + same storageKey is
 * what lets analytics-frontend read the session dashboard-frontend already
 * wrote to localStorage. Adding `storageKey` here would silently break that
 * cross-SPA session handoff for every consumer at once.
 */
export const BROWSER_SUPABASE_AUTH_OPTIONS = {
  autoRefreshToken: true,
  persistSession: true,
  detectSessionInUrl: false,
} as const;
